import React from "react";
import ReactQuill from "react-quill";
import Quill from "quill/dist/quill.js";
import { PropTypes } from "prop-types";
import "react-quill/dist/quill.snow.css";
import "./editor.css";

import MagicUrl from "quill-magic-url";

Quill.register("modules/magicUrl", MagicUrl);

// tags to add to the toolbar
let Inline = Quill.import("blots/inline");

class MarkBlot extends Inline {}
MarkBlot.blotName = "spoiler";
MarkBlot.tagName = "tg-spoiler";
Quill.register(MarkBlot);

class Mono extends Inline {}
Mono.blotName = "mono";
Mono.tagName = "code";
Quill.register(Mono);

// custom icons for the toolbar
let icons = ReactQuill.Quill.import("ui/icons");
icons["spoiler"] = `
  <svg
    stroke="currentColor"
    fill="#444"
    stroke-width="0"
    viewBox="0 0 24 24"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      fill="#444"
      class="ql-stroke"
      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
    ></path>
  </svg>
`;
icons["mono"] = `
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="none"
    stroke=" #fff">
    <path fill="#fff"
    stroke=" #fff" style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Sans" d="M 28.875 7.96875 A 1.0001 1.0001 0 0 0 28.78125 8 A 1.0001 1.0001 0 0 0 28 9.125 L 31 36.125 A 1.0001 1.0001 0 0 0 32 37 L 33 37 A 1.0001 1.0001 0 0 0 33.9375 36.3125 L 37 27.125 L 40.0625 36.3125 A 1.0001 1.0001 0 0 0 41 37 L 42 37 A 1.0001 1.0001 0 0 0 43 36.125 L 46 9.125 A 1.0001 1.0001 0 0 0 44.9375 7.96875 A 1.0001 1.0001 0 0 0 44.8125 8 A 1.0001 1.0001 0 0 0 44 8.875 L 41.25 33.625 L 38.03125 24.03125 A 1.0001 1.0001 0 0 0 37 22.84375 A 1.0001 1.0001 0 0 0 35.96875 23.96875 L 32.75 33.625 L 30 8.875 A 1.0001 1.0001 0 0 0 28.875 7.96875 z M 11.8125 8 A 1.0001 1.0001 0 0 0 11.03125 8.75 L 4.03125 35.75 A 1.0004882 1.0004882 0 1 0 5.96875 36.25 L 8.875 25 A 1.001098 1.001098 0 0 0 9 25 L 17 25 A 1.0001 1.0001 0 0 0 17.09375 25 L 17.125 25 L 20.03125 36.25 A 1.0004882 1.0004882 0 1 0 21.96875 35.75 L 14.96875 8.75 A 1.0001 1.0001 0 0 0 14 8 L 12 8 A 1.0001 1.0001 0 0 0 11.90625 8 A 1.0001 1.0001 0 0 0 11.8125 8 z M 12.78125 10 L 13.21875 10 L 16.59375 23 L 9.40625 23 L 12.78125 10 z M 2 38 L 2 39 L 2 41 A 1.0001 1.0001 0 0 0 3 42 L 23 42 A 1.0001 1.0001 0 0 0 24 41 L 24 39 L 24 38 L 22 38 L 22 39 L 22 40 L 4 40 L 4 39 L 4 38 L 2 38 z M 26 38 L 26 39 L 26 41 A 1.0001 1.0001 0 0 0 27 42 L 47 42 A 1.0001 1.0001 0 0 0 48 41 L 48 39 L 48 38 L 46 38 L 46 39 L 46 40 L 28 40 L 28 39 L 28 38 L 26 38 z"/>
</svg>
`;

/*
 * Editor component with custom toolbar and content containers
 */
const TextEditor = ({ value, onChange, placeholder }) => {
  return (
    <div className="text-editor">
      <ReactQuill
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        modules={TextEditor.modules}
        formats={TextEditor.formats}
        theme={"snow"} // pass false to use minimal theme
      />
    </div>
  );
};
/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */

TextEditor.modules = {
  toolbar: [
    ["bold", "italic", "mono", "underline", "strike", "link"],
    ["clean"],
  ],
  // toolbar: toolbarOptions,

  clipboard: {
    matchVisual: false,
  },
  magicUrl: true,
};
/*
 * PropType validation
 */
TextEditor.propTypes = {
  placeholder: PropTypes.string,
};

export default TextEditor;
